import {useEffect, useState, useRef, Fragment } from "react";
import {useNavigate} from "react-router-dom";


import {useDispatch} from "react-redux";
import MainLayout from "../../../../commons/layout/MainLayout/index";

import HeaderHs2 from "../../../../commons/components/Header/headerHs2";

import TabsComponent from "../../../../commons/components/Tabs/TabsComponent";
import ROUTERS from "../../../../commons/constans/router";
import InfiniteScroll from 'react-infinite-scroll-component';
import API, {ROUTES} from "../../../../commons/api/api";
import {usePoint} from "../../../../commons/customHooks/GiftBox";
import _style from "./_styles.scss"
import { currencyFormat, priceFormat } from "../../../../utils/helpers";
import BacktoTopComponent from "../../../../commons/components/BackToTop";
import SkeletonLoadingComponent from "../../../../commons/components/SkeletonLoading";
import { useUser } from "../../../../commons/customHooks/Account";

const formatTimeUTC = (time, separate = ".") =>{

    var dateTime = new Date(time);
    let year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    let day = dateTime.getDate();
    let hours = dateTime.getUTCHours() + 9;
    let minutes = dateTime.getUTCMinutes();
    console.log(hours,'hours123',dateTime)
    day =  day < 10 ? '0'+day : day
    month =  month < 10 ? '0'+month : month
    hours =  hours < 10 ? '0'+hours : hours
    minutes =  minutes < 10 ? '0'+minutes : minutes
    var timeFormat = year + '.'+month + '.' +day + ' ' + hours + ':' + minutes

    return timeFormat;
}

const RenderMsgDataEmpty = ({type}) => {
    let msg = ''

    switch(type) {
        case 'paid':
            msg = '포인트 지급 내역의 데이터가 없습니다'
            break;
        case 'income':
            msg = '포인트 적립 내역의 데이터가 없습니다'
            break;
        case 'grant':
            msg = '포인트 지급 내역 데이터가 없습니다'
            break;
        case 'recall':
            msg = '포인트 회수 내역 데이터가 없습니다'
            break;
        default:
            // msg = '포인트 적립 및 지급 내역의 데이터가 없습니다'
            msg = '데이터가 없습니다'
    }
    return <div className="text-center mt-4" style={{fontSize:'14px'}} dangerouslySetInnerHTML={{__html: msg}} />;
}

const GiftboxPointHistoryPageComponent = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [point] = usePoint()
    const listInnerRef = useRef();

    var listHistoryPoint = props?.data?.data || [];

    const [pointHistoryList, setPointHistoryList] = useState([])
    const [type, setType] = useState('')

    const [page, setPage] = useState(1)
    const [statusLoading, setStatusLoading] = useState(false)
    const [mounted, setMounted] = useState(false)
    const [showScroll, setShowScroll] = useState(false)
    const [historyList, setHistoryList] = useState([])
    const { user } = useUser();

    const backPage = () => {
        navigate(-1)

    }
    const backToTop = () => {
        // scrollTo(0, 0)
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    useEffect(() => {
        let dataList = []
        if(historyList.length > 0) {
            dataList= [...historyList,...(props?.data?.data || [])]
        }else {
            dataList=props?.data?.data || [];
        }

        setHistoryList(dataList)
    }, [props?.data?.data]);

    const fetchMoreData = () => {

        // if (props?.data?.from < props?.data?.last_page && statusLoading) {
            let pageLoad = page + 1;
            setPage(pageLoad)
            let params= '?page='+pageLoad+'&type='+type
            props.fetchMore(params)
        // }

    }

    useEffect(() => {

        if(props.loadMore){
            setStatusLoading(true)
        }else {
            setStatusLoading(false)
        }
    }, [props]);

    const sortList = (type) => {
        setHistoryList([])
        setType(type)
        setPage(1)
        let params= '?page=1'+'&type='+type
        props.sortData(params)
    }


    // if(!mounted){
    //     window.addEventListener('scroll', function() {
    //         if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
    //             setShowScroll(true)
    //         }else {
    //             setShowScroll(false)
    //         }
    //     });
    // }
    //
    // useEffect(() =>{
    //     setMounted(true)
    // },[])

    useEffect(() => {
        const handleScroll = () => {
            window.addEventListener("scroll", () => {
                if (window.scrollY > 400) {
                    setShowScroll(true)
                } else {
                    setShowScroll(false)
                }
            });
        }

        handleScroll()

        return () => window.removeEventListener("scroll", handleScroll)
    }, []);

    console.log(user, 'useruser');

    const loadingDiv = <div className="point-history-list__data__item">
        <label className="item-date-time m-0">
            <SkeletonLoadingComponent circle={false} width="100px" height="14px"/>
        </label>
        <div className="title-point d-flex align-items-center justify-content-between">
            <label className="item-title m-0">
                <SkeletonLoadingComponent circle={false} width="150px" height="21px"/>
            </label>
            <div className="item-point">
                <SkeletonLoadingComponent circle={false} width="60px" height="21px"/>
            </div>
        </div>
    </div>


    return (
        <MainLayout pageID={"giftbox-point-history"} displayBottomNav={false} >
            <HeaderHs2
                title={"포인트 내역"}
                labelLeft={true}
                labelRight={false}
                handleLabelLeft={backPage}
            />
            <div className="wrapper" >

                <div className="main-giftbox-point-history">
                    <div className="point-history-head">
                        <div className=" point-history-current">
                            <div className="position-relative">
                                <img className="point-history-current__bgr" src="/images/point_detail_bg.svg"/>
                                <div className="point-history-current__content">
                                    <h3 className="point-history-title">
                                        <strong>{user?.nickname || ''}</strong> 회원님 보유포인트
                                    </h3>
                                    <div className="point-history-data">
                                        <img className="point-history-data__icon" src="/images/icon_point.svg"/>
                                        <label className="point-history-data__value m-0">{currencyFormat(point)}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`point-history-filter ${props?.loading ? 'disabled-filter' : ''}`}>
                            <button className={`btn btn-rounded m-0 btn-filter ${type == '' ? ' btn-primary' : ' btn-light'}`} disabled={type == '' ? true : false} onClick={() => sortList('')}>전체</button>
                            <button className={`btn btn-rounded m-0 btn-filter ${type == 'paid' ? ' btn-primary' : ' btn-light'}`} disabled={type == 'paid' ? true : false}  onClick={() => sortList('paid')}>사용</button>
                            <button className={`btn btn-rounded m-0 btn-filter ${type == 'income' ? ' btn-primary' : ' btn-light'} `} disabled={type == 'income' ? true : false}  onClick={() => sortList('income')}>적립</button>
                            <button className={`btn btn-rounded m-0 btn-filter ${type == 'grant' ? ' btn-primary' : ' btn-light'} `} disabled={type == 'grant' ? true : false}  onClick={() => sortList('grant')}>지급</button>
                            <button className={`btn btn-rounded m-0 btn-filter ${type == 'recall' ? ' btn-primary' : ' btn-light'} `} disabled={type == 'recall' ? true : false}  onClick={() => sortList('recall')}>회수</button>
                        </div>
                    </div>
                    <div className="point-history-list">
                        <div className="point-history-list__data">
                            {(props.loading && !historyList.length) ? (
                                [...Array(5).keys()].map(e => (
                                    <Fragment key={e}>
                                        {loadingDiv}
                                    </Fragment>
                                ))
                            ) : (
                                historyList.length > 0 ? (
                                    <InfiniteScroll
                                        dataLength={historyList.length}
                                        next={fetchMoreData}
                                        hasMore={statusLoading}
                                        loader={loadingDiv}
                                    >
                                        {historyList.length > 0 && historyList.map((value, index) => (
                                            <div className="point-history-list__data__item" key={index} >
                                                <label className="item-date-time m-0">
                                                    {formatTimeUTC(value.created_at)}
                                                </label>
                                                <div className="title-point d-flex align-items-center justify-content-between">
                                                    <label className="item-title m-0">
                                                        {value.content}
                                                    </label>
                                                    <div className="item-point">
                                                        <label
                                                            className="m-0 item-point__value">{value.type == 'income' || value.type == 'grant' ? '+ ' : '- '}{priceFormat(value.amount)} P</label>
                                                        {value.type == 'income' ? (<div className="item-point__plus-point">
                                                            <img className="item-point__plus-point__icon"
                                                                 src="/images/icon_speech_bubble_g.svg"/>
                                                            <label className="item-point__plus-point__text m-0">적립</label>
                                                        </div>) : ''}

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </InfiniteScroll>
                                ) :(
                                    <RenderMsgDataEmpty type={type} />
                                )
                            )}
                        </div>
                    </div>
                </div>
                {/*{showScroll ? (<div className="back-to-top " onClick={() => backToTop()}>*/}
                {/*    <label className="back-to-top__text">top</label>*/}
                {/*    <img className="back-to-top__icon" src="/images/icon_top.svg"/>*/}
                {/*</div>) : ''}*/}
                <BacktoTopComponent />


            </div>
        </MainLayout>
    );
};

export default GiftboxPointHistoryPageComponent;
